/**
 * @generated SignedSource<<0133b5641280f07cb4c49bc2957efc8f>>
 * @relayHash ff1f87da40139e7cb97568284d738116
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18ec07f0382b9640ed7eece3e79d5a9fac2ebaced1e0e3e67ff91104dd4fe371

import type { ConcreteRequest } from 'relay-runtime';
export type RecordingDisclaimer_conversationConfigurationQuery$variables = {
  cloudId: string;
  containerId: string;
  shouldFetch: boolean;
};
export type RecordingDisclaimer_conversationConfigurationQuery$data = {
  readonly agentStudio_conversationConfiguration?: {
    readonly __typename: "AgentStudioConversationConfig";
    readonly isEnabled: boolean | null;
  } | {
    readonly __typename: "QueryError";
    readonly message: string | null;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
};
export type RecordingDisclaimer_conversationConfigurationQuery = {
  response: RecordingDisclaimer_conversationConfigurationQuery$data;
  variables: RecordingDisclaimer_conversationConfigurationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldFetch"
  }
],
v1 = [
  {
    "condition": "shouldFetch",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "containerId",
            "variableName": "containerId"
          }
        ],
        "kind": "LinkedField",
        "name": "agentStudio_conversationConfiguration",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isEnabled"
              }
            ],
            "type": "AgentStudioConversationConfig"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RecordingDisclaimer_conversationConfigurationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecordingDisclaimer_conversationConfigurationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "18ec07f0382b9640ed7eece3e79d5a9fac2ebaced1e0e3e67ff91104dd4fe371",
    "metadata": {},
    "name": "RecordingDisclaimer_conversationConfigurationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "010d57bf97f55b15bec1a8d69c471703";

export default node;
